import { useTranslator } from '@bluebeam/react-i18n';
import { Button } from 'components/lib';
import largeRFI from 'images/large-rfi.svg';
import React, { FC } from 'react';
import { Project } from 'records/Project';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  onCreateRFI: Function;
}

const NoRFIItems: FC<Props> = ({ onCreateRFI, appState }) => {
  const { translate } = useTranslator(['buttons', 'noRfiItems']);
  const { projects, selectedProject } = appState;
  const { permissions } = projects.get(selectedProject, new Project());

  const handleCreateRFI = (): void => {
    onCreateRFI();
  };

  return (
    <div id="no-rfi-items" className="column justify-center items-center pt9">
      <div className="mb4 fill-gray-5">
        {/* <EmptyState width="96px" height="96px" /> */}
        <img src={largeRFI} alt="large RFI illustration" />
      </div>
      <div className="font-size-7 color-gray-9 mb2">
        {translate('noRfiItems:noRfis')}
      </div>
      {permissions.createRfi ? (
        <>
          <div className="font-size-5 color-gray-6 mb6">
            {translate('noRfiItems:createRfi')}
          </div>
          <div>
            <Button
              id="no-rfi-items-create-item-btn"
              size="large"
              variant="secondary"
              onClick={handleCreateRFI}
            >
              {translate('buttons:createItem')}
            </Button>
          </div>
        </>
      ) : (
        <div className="font-size-5 color-gray-6 mb6">
          {translate('noRfiItems:disclaimer')}
        </div>
      )}
    </div>
  );
};

export default withAppStore<Props>(NoRFIItems);
